export const getRealmRolesFromToken = (token: string | null | undefined): string[] => {
  if (!token || typeof token !== 'string') return [];

  try {
    const parts = token.split('.');
    if (parts.length < 2) return [];
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
    const roles = payload?.realm_access?.roles;
    return Array.isArray(roles) ? roles : [];
  } catch {
    return [];
  }
};

